<template>
    <div class="fixedLeft">
        <div v-if="!isLogin" class="fixedLeftPerson fixedLeftDiv pointer" @click="goPerson">
            <a class="image-link-a" onclick="return false">
                <img :src="person">
                <p class="fixedLeftP">{{ $t('homes.person') }}</p>
            </a>
        </div>
        <div v-if="isLogin" class="fixedLeftPerson fixedLeftDiv pointer" @click="goEzt3Login">
            <img :src="message">
            <p class="fixedLeftP">Pre-registration</p>
        </div>
        <div class="fixedLeftGoTop fixedLeftDiv pointer" @click="goTopScroll">
            <img :src="goTop">
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getAuthCode } from '@/api/index'
import exhibitor from '@/assets/homeImages/exhibitor.png'
import person from '@/assets/homeImages/person.png'
import message from '@/assets/homeImages/message.png'
import goTop from '@/assets/homeImages/goTop.png'

export default {
    data() {
        return {
            exhibitor,
            person,
            message,
            goTop
        }
    },
    computed: {
        ...mapGetters([  'isLogin' ])
    },
    methods: {
        // 观众登录
        goPerson() {
            window.PC.$RangersEvent("Homepagesuspension_visitor_Click")
            this.$store.commit('SET_SUBJECTTYPE', 'VISITOR')
            this.loginSource('/login/person')
        },
        // 跳转ezt3
        async goEzt3Login() {
            const authData = await getAuthCode()
            const data = authData.data
            if (data.code === 1000) {
                const authCode = data.data
                // 正式环境
                const target = `https://regcn.cacshow.com/#/jump?exhibitionId=1960598147339644930&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1965237171072868353&isOpenAdapt=yes&sourceCode=XCXen&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`
                
                // const target = `http://172.16.1.252:5173/#/jump?exhibitionId=1823536898857046018&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1823539766322335746&isOpenAdapt=yes&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`

                window.location.href = target
            }
        },
        // 回到顶部
        goTopScroll() {
            cancelAnimationFrame(timer)
            var timer = requestAnimationFrame(function fn() {
                var oTop = document.body.scrollTop || document.documentElement.scrollTop
                if (oTop > 0) {
                scrollBy(0, -50)
                timer = requestAnimationFrame(fn)
                } else {
                cancelAnimationFrame(timer)
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.fixedLeft {
    padding: 8px 0;
    position: fixed;
    right: 15px;
    bottom: 50px;
    width: 70px;
    z-index: 1202;
    
    border-radius: 5px;

    img {
        width: 40px;
        height: 40px;
    }

    .fixedLeftDiv {
        padding: 8px;
        text-align: center;
        cursor: pointer;
    }

    .fixedLeftP {
        font-size: 10px;
        padding: 10px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.10);
        text-align: center;
    }

    .fixedLeftGoTop {
        padding-bottom: 8px;
    }
}
</style>
